// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3XvxL","label":"Labeled_label__5PO_j","divider":"Labeled_divider__4Nu1G"};